import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { GAMES_DESCRIPTION } from '../settingsForGames';
import type { GameType } from './types';

interface PropsType {
  game: GameType;
}

const ShowcaseActions = ({ game }: PropsType) => {
  const [gameMoreInfoOpened, setGameMoreInfoOpened] = useState(false);

  return (
    <>
      <Dialog
        open={gameMoreInfoOpened}
        onClose={() => setGameMoreInfoOpened(false)}
      >
        <DialogTitle>{game.name}</DialogTitle>
        <DialogContent>
          <div>{GAMES_DESCRIPTION[game.name]}</div>
          <br />
          <div>
            {Object.keys(game.settings).map((settingName) => (
              <div key={settingName}>
                <b>{settingName}</b>: {game.settings[settingName]}
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
      <Button
        variant="contained"
        style={{ minWidth: 0, width: '32px', height: '32px' }}
        color="info"
        onClick={() => setGameMoreInfoOpened(true)}
      >
        <InfoOutlineIcon fontSize="small" />
      </Button>
    </>
  );
};

export default ShowcaseActions;
